module.exports = __webpack_public_path__ + "images/category_lp/retro_game/store_images/1_04393038207dfdca81da52613982264b.png";